"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./SubStepper.css");

var _styles = {
  "container": "SubStepper__container___3QeBn",
  "step-icon": "SubStepper__step-icon___11XU0",
  "sub-step": "SubStepper__sub-step___2BrBu",
  "active": "SubStepper__active___2bpcz",
  "substep-cta": "SubStepper__substep-cta___21G2x"
};

const styles = _bind.default.bind(_styles);

const SubStep = (0, _mobxReact.observer)(({
  index,
  isActive,
  isComplete,
  text
}) => {
  return _react.default.createElement(_.Flex, {
    gap: 8,
    key: index,
    alignItems: 'center',
    padding: [12, 80, 12, 8],
    className: styles('sub-step', {
      active: isActive
    })
  }, _react.default.createElement("div", {
    className: styles('step-icon')
  }, isComplete ? _react.default.createElement(_.Icon, {
    name: _.IconEnum.check,
    color: _.Color.semantic.$success50
  }) : _react.default.createElement(_.Text, {
    text: index,
    variant: 'medium',
    size: 13
  })), _react.default.createElement(_.Text, {
    text: text,
    variant: 'medium',
    size: 13
  }));
});
const SubStepper = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  steps,
  currentStep = 0,
  ctaText,
  ctaOnClick
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);
  return _react.default.createElement(_.Flex, {
    alignItems: 'center',
    justifyContent: 'flex-start',
    "data-testid": dataTestId,
    className: composed_classname
  }, steps.map((step, index) => _react.default.createElement(SubStep, {
    index: index + 1,
    isActive: currentStep >= index,
    isComplete: currentStep > index,
    key: index,
    text: step
  })), ctaText && ctaOnClick && _react.default.createElement(_.Button, {
    className: styles('substep-cta'),
    label: ctaText,
    onClick: ctaOnClick,
    variant: 'tertiary',
    dataTestId: `${dataTestId}-cta-button`
  }));
});
var _default = SubStepper;
exports.default = _default;